import React, { useEffect, createElement } from 'react';
const GlobalFallback = () => {
  useEffect(() => {
    const DEST = 'https://www.thaura.co/products/drift';
    // Run immediately and also on DOMContentLoaded
    const setupRedirects = function () {
      // Target all buttons except review navigation buttons
      document.querySelectorAll('button:not([aria-label="Previous testimonials"]):not([aria-label="Next testimonials"])').forEach(function (el) {
        el.addEventListener('click', function (e) {
          window.location.href = DEST;
        });
      });
      // Handle anchor tags
      document.querySelectorAll('a:not(.testimonial-nav)').forEach(el => {
        el.href = DEST;
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener');
      });
      // Add CSS to ensure CTAs are clickable
      if (!document.getElementById('cta-styles')) {
        const style = document.createElement('style');
        style.id = 'cta-styles';
        style.textContent = `
          .cta-button, a[href], button { 
            position: relative; 
            z-index: 10; 
            pointer-events: auto !important; 
            cursor: pointer;
          } 
          .overlay, .cookie-banner, .sticky-header { 
            pointer-events: none; 
          }
        `;
        document.head.appendChild(style);
      }
    };
    // Run immediately
    setupRedirects();
    // Also run when DOM is fully loaded
    document.addEventListener('DOMContentLoaded', setupRedirects);
    // Global click handler to catch any clicks that might be missed
    document.addEventListener('click', function (e) {
      const isReviewNav = e.target.closest('button[aria-label="Previous testimonials"], button[aria-label="Next testimonials"]');
      if (isReviewNav) return;
      const isButton = e.target.closest('button, a, [role="button"]');
      if (isButton) {
        setTimeout(function () {
          window.location.href = DEST;
        }, 0);
      }
    }, true);
    return () => {
      document.removeEventListener('DOMContentLoaded', setupRedirects);
    };
  }, []);
  return null;
};
export default GlobalFallback;